import { useTagStore, jsonHeaders } from "./tag-store.js";
import {
  userRecipeTagPath,
  userRecipeTagsPath,
  bulkDestroyUserRecipeTagsPath,
  countUserRecipeTagsPath,
  prototypeUserRecipeTagsPath,
  bulkAddUserRecipeTagsPath,
  bulkRemoveUserRecipeTagsPath,
} from "routes";

export const useRecipeTagStore = () => {
  return useTagStore({
    modelName: "recipe",
    tagModelName: "recipe_tag",
    tagPath: userRecipeTagPath,
    countTagsPath: countUserRecipeTagsPath,
    tagsPath: userRecipeTagsPath,
    bulkDestroyTagsPath: bulkDestroyUserRecipeTagsPath,
    prototypeTagsPath: prototypeUserRecipeTagsPath,
    additionalActions: {
      async bulkAddTags({ ids, tagNames }) {
        const response = await fetch(bulkAddUserRecipeTagsPath(this.userId), {
          method: "POST",
          headers: jsonHeaders,
          body: JSON.stringify({ recipe_ids: ids, tags: tagNames }),
        });

        await this.loadAllTags();
        const { skipped_locked_count: skippedLockedCount } = await response.json();
        return skippedLockedCount;
      },

      async bulkRemoveTags({ ids, tagNames }) {
        const response = await fetch(bulkRemoveUserRecipeTagsPath(this.userId), {
          method: "POST",
          headers: jsonHeaders,
          body: JSON.stringify({ recipe_ids: ids, tags: tagNames }),
        });

        await this.loadAllTags();
        const { skipped_locked_count: skippedLockedCount } = await response.json();
        return skippedLockedCount;
      },
    },
  });
};
